export const LOGIN_CONTROL_NAMES = {
    username: 'username',
    password: 'password'
}